/* global axios */
import ApiClient from '../ApiClient';

class AiFocusAgentLogsAPI extends ApiClient {
  constructor() {
    super('aifocus/agents', { accountScoped: true });
  }

  /**
   * Get logs for an agent
   * @param {number} agentId - Agent ID
   * @param {Object} params - Query parameters
   * @param {string} params.level - Filter by level (debug, info, warn, error, success)
   * @param {string} params.event_type - Filter by event type
   * @param {string} params.since - ISO timestamp to get logs since
   * @param {number} params.page - Page number
   * @param {number} params.per_page - Items per page
   */
  getLogs(agentId, params = {}) {
    return axios.get(`${this.url}/${agentId}/logs`, { params });
  }

  /**
   * Get a single log entry
   * @param {number} agentId - Agent ID
   * @param {number} logId - Log ID
   */
  getLog(agentId, logId) {
    return axios.get(`${this.url}/${agentId}/logs/${logId}`);
  }

  /**
   * Get stats for an agent's logs
   * @param {number} agentId - Agent ID
   */
  getStats(agentId) {
    return axios.get(`${this.url}/${agentId}/logs/stats`);
  }

  /**
   * Stream logs in real-time (long polling)
   * @param {number} agentId - Agent ID
   * @param {string} since - ISO timestamp to get logs since
   * @param {number} timeout - Long poll timeout in seconds (default: 30)
   */
  streamLogs(agentId, since = null, timeout = 30) {
    const params = { timeout };
    if (since) {
      params.since = since;
    }
    return axios.get(`${this.url}/${agentId}/logs/stream`, { params });
  }

  /**
   * Clear logs for an agent
   * @param {number} agentId - Agent ID
   * @param {number} daysToKeep - Keep logs from last N days (0 = clear all)
   */
  clearLogs(agentId, daysToKeep = 0) {
    return axios.delete(`${this.url}/${agentId}/logs/clear`, {
      params: { days_to_keep: daysToKeep },
    });
  }
}

export default new AiFocusAgentLogsAPI();
